// extracted by mini-css-extract-plugin
export default {"root":"ViewStatementContent_root__YamZb","is-loading":"ViewStatementContent_is-loading__N8F7v"};